/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  JSON: { input: any; output: any };
};

export type Agreement = {
  __typename?: 'Agreement';
  /** The bonus of the signed Agreement. */
  bonus?: Maybe<Scalars['String']['output']>;
  /** When the Agreement was created. */
  created_at?: Maybe<Scalars['Date']['output']>;
  /** Can be set to a currency other than what is standard, USD. */
  currency_override?: Maybe<Scalars['String']['output']>;
  /** The last time the Agreement was signed. */
  date_signed?: Maybe<Scalars['Date']['output']>;
  /** The hours per month of the signed Agreement. */
  hours_per_month?: Maybe<Scalars['String']['output']>;
  /** Udacity ID of the Agreement. */
  id?: Maybe<Scalars['String']['output']>;
  /** The max payments per month of the signed Agreement. */
  max_payments_per_month?: Maybe<Scalars['String']['output']>;
  /** Udacity ID of the Mentor. */
  mentor_id?: Maybe<Scalars['String']['output']>;
  /** The pay rate of the signed Agreement. */
  pay_rate?: Maybe<Scalars['String']['output']>;
  /** The role of the Agreement. */
  role?: Maybe<Role>;
  /** The status of the Agreement. */
  status?: Maybe<Status>;
  /** The last time this Agreement was updated. */
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type Mentor = {
  __typename?: 'Mentor';
  /** Agreement version for this mentor (may be NULL). */
  agreement_version?: Maybe<Scalars['String']['output']>;
  /** Indicates whether or not mentor has agreed to the current TOS. */
  agrees_terms_of_service?: Maybe<Scalars['Boolean']['output']>;
  /** Mentor application with Nanodegree and service information. */
  application?: Maybe<Scalars['JSON']['output']>;
  /** Languages approved by Ops (BCP 47 / INTL Team standards). */
  approved_languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Indicates whether or not the mentor is willing to dedicate a certain number of hours per week for mentorship services. */
  available_hours?: Maybe<Scalars['Int']['output']>;
  /** Profile image URL. */
  avatar_url?: Maybe<Scalars['String']['output']>;
  /** A few sentences describing background / experience. */
  bio?: Maybe<Scalars['String']['output']>;
  /** Indicates whether or not the mentor is globally blocked and, thus, should not be allowed to serve as a mentor (e.g., for Classroom Mentorship, Reviews, etc.). */
  blocked?: Maybe<Scalars['Boolean']['output']>;
  /** Specific NDs where the mentor is no longer allowed to provide mentorship. */
  blocked_nds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** City name, e.g. Mountain View, populated via Payoneer. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country code (ISO 3166-1 alpha-2), populated via Payoneer. */
  country?: Maybe<Scalars['String']['output']>;
  /** When this mentor was created. */
  created_at?: Maybe<Scalars['Date']['output']>;
  /** For example, "BS, Electrical Engineering". */
  educational_background?: Maybe<Scalars['String']['output']>;
  /** Indicates whether or not the mentor is gig approved, i.e. not subject to laws like California AB5. */
  gig_approved?: Maybe<Scalars['Boolean']['output']>;
  /** GitHub profile URL. */
  github_url?: Maybe<Scalars['String']['output']>;
  /** Agreement version for this government mentor (may be NULL). */
  gov_mentor_agreement_version?: Maybe<Scalars['String']['output']>;
  /** Intro message to mentees. */
  intro_msg?: Maybe<Scalars['String']['output']>;
  /** Locale adjustment factor for knowledge */
  knowledge_pricing_factor?: Maybe<Scalars['String']['output']>;
  /** Languages submitted by mentor (BCP 47 / INTL Team standards). */
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** LinkedIn profile URL. */
  linkedin_url?: Maybe<Scalars['String']['output']>;
  /** Agreement version for this mentor (may be NULL). */
  payoneer_status?: Maybe<Scalars['String']['output']>;
  /** PayPal email address. */
  paypal_email?: Maybe<Scalars['String']['output']>;
  /** Phone number (ITU E.164 recommendation). */
  phone_number?: Maybe<Scalars['String']['output']>;
  /** Locale adjustment factor for reviews */
  reviews_pricing_factor?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Services>;
  /** State code, e.g. CA for California, USA, populated via Payoneer. */
  state?: Maybe<Scalars['String']['output']>;
  /** Timezone in which the mentor resides and/or will be available. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Udacity UID of the mentor. */
  uid: Scalars['String']['output'];
  /** The last time this mentor was updated. */
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createAgreement?: Maybe<Agreement>;
  createEGPMentorAgreement?: Maybe<Agreement>;
  createMentor?: Maybe<Mentor>;
  updateAgreement?: Maybe<Agreement>;
  updateMentor?: Maybe<Mentor>;
};

export type MutationCreateAgreementArgs = {
  bonus?: InputMaybe<Scalars['String']['input']>;
  date_signed?: InputMaybe<Scalars['Date']['input']>;
  hours_per_month?: InputMaybe<Scalars['String']['input']>;
  max_payments_per_month?: InputMaybe<Scalars['String']['input']>;
  mentor_id: Scalars['String']['input'];
  pay_rate?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  status: Status;
};

export type MutationCreateEgpMentorAgreementArgs = {
  bonus?: InputMaybe<Scalars['String']['input']>;
  date_signed?: InputMaybe<Scalars['Date']['input']>;
  hours_per_month?: InputMaybe<Scalars['String']['input']>;
  max_payments_per_month?: InputMaybe<Scalars['String']['input']>;
  mentor_id: Scalars['String']['input'];
  pay_rate?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  status: Status;
};

export type MutationCreateMentorArgs = {
  agreement_version?: InputMaybe<Scalars['String']['input']>;
  application?: InputMaybe<Scalars['JSON']['input']>;
  approved_languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  available_hours?: InputMaybe<Scalars['Int']['input']>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  blocked_nds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  educational_background?: InputMaybe<Scalars['String']['input']>;
  github_url?: InputMaybe<Scalars['String']['input']>;
  gov_mentor_agreement_version?: InputMaybe<Scalars['String']['input']>;
  intro_msg?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  paypal_email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};

export type MutationUpdateAgreementArgs = {
  bonus?: InputMaybe<Scalars['String']['input']>;
  date_signed?: InputMaybe<Scalars['Date']['input']>;
  hours_per_month?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  max_payments_per_month?: InputMaybe<Scalars['String']['input']>;
  mentor_id?: InputMaybe<Scalars['String']['input']>;
  pay_rate?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  status?: InputMaybe<Status>;
};

export type MutationUpdateMentorArgs = {
  agreement_version?: InputMaybe<Scalars['String']['input']>;
  application?: InputMaybe<Scalars['JSON']['input']>;
  approved_languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  available_hours?: InputMaybe<Scalars['Int']['input']>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  blocked_nds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  educational_background?: InputMaybe<Scalars['String']['input']>;
  github_url?: InputMaybe<Scalars['String']['input']>;
  gov_mentor_agreement_version?: InputMaybe<Scalars['String']['input']>;
  intro_msg?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  paypal_email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  agreement?: Maybe<Agreement>;
  agreements?: Maybe<Array<Maybe<Agreement>>>;
  /** Check if at least one mentor from the given UIDs has the specified language in their approved_languages. */
  anyMentorHasLanguage?: Maybe<Scalars['Boolean']['output']>;
  mentor?: Maybe<Mentor>;
  mentors?: Maybe<Array<Maybe<Mentor>>>;
};

export type QueryAgreementArgs = {
  id: Scalars['String']['input'];
};

export type QueryAgreementsArgs = {
  mentor_id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAnyMentorHasLanguageArgs = {
  language: Scalars['String']['input'];
  uids: Array<InputMaybe<Scalars['String']['input']>>;
};

export type QueryMentorArgs = {
  uid: Scalars['String']['input'];
};

export enum Role {
  CareerCoach = 'career_coach',
  CommunityModerator = 'community_moderator',
  Guru = 'guru',
  SessionLead = 'session_lead',
  Tutor = 'tutor',
}

/** Services in which the mentor participates. */
export type Services = {
  __typename?: 'Services';
  /** Indicates whether or not the mentor is a Classroom mentor. */
  classroom_mentorship?: Maybe<Scalars['Boolean']['output']>;
  /**
   * DEPRECATED
   * @deprecated 1:1 personal mentors in hub are no longer avaliable.
   */
  community?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether or not the mentor is a Connect session lead. */
  connect?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether or not the mentor is a government mentor. */
  government_mentorship?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether or not the mentor is a certified reviewer. */
  reviews?: Maybe<Scalars['Boolean']['output']>;
};

export enum Status {
  PendingSignature = 'pending_signature',
  Signed = 'signed',
  Withdrawn = 'withdrawn',
}
